import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { setHeader } from '../http/set-header';
import { HTTP_HEADER_W3C_BAGGAGE, W3cBaggage } from '../http/w3cBaggage';

import { EventCorrelationIdService } from './event-correlation-id.service';

/**
 * Only used for CTI (b2e). It probably should be moved to b2e-utils.
 * It acts the same as a tracing SPAN, but it is a business aspect and not a technical aspect.
 */
export const eventCorrelationIdInterceptor: HttpInterceptorFn = (req, next) => {
    const eventCorrelationId = inject(EventCorrelationIdService).get();
    if (!eventCorrelationId) {
        return next(req);
    }
    const baggage = new W3cBaggage(req).add('eventCorrId', eventCorrelationId);
    const requestWithHeader = setHeader(req, HTTP_HEADER_W3C_BAGGAGE, baggage.toString());
    return next(requestWithHeader);
};
